var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.keepAlive)?_c('NavigationBar'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(!_vm.$route.meta.footerkeepAlive)?_c('common-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }